import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { OrderDetailResponse } from "types/order-detail";

interface OrderDetailPayload {
    order_id: string;
}
interface GetOrderDetailResponse extends AxiosResponse {
    data: OrderDetailResponse
}

const useDetailOrder = ({ order_id }: OrderDetailPayload) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    return useQuery<unknown, unknown, GetOrderDetailResponse>({
        queryKey: ['get-order-detail', order_id],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/order/detail/${order_id}`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
};

export default useDetailOrder;
